import { Component } from '@angular/core';
import { GameScene } from './game/game-scene';
import { screen } from './game/game-config';
import * as Phaser from 'phaser';


interface GameInstance extends Phaser.Types.Core.GameConfig {
  instance?: Phaser.Game
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  game: GameInstance = {
    type: Phaser.WEBGL,
    scene: [GameScene],
    render: {
      pixelArt: true
    }
  }

  constructor() {
    this.game.width = screen.width
    this.game.height = screen.height
  }
}
